import CustomerService from "../../../common/services/customer/CustomerService";
import RfpChatService from "../../../common/services/rfp/RfpChatService";
import RfpMessageService from "../../../common/services/rfp/RfpMessageService";

import { ADD_RFP_MESSAGE, CREATE_RFP_MESSAGE, GET_CUSTOMER_RFP_CHATS, GET_RFP_CHAT_MESSAGES, GET_RFP_MESSAGES, SWITCH_RFP_CHAT_DIALOG, UPDATE_RFP_MESSAGE } from "./actions";

export default {
    state: {
        chatvisible: true,
        chat: undefined,
        chatRfpDetails: undefined,
        //currency: [{ name: "$" }, { name: "£" }, { name: "€" }, { name: "AUD$" }],
        price: {
            priceValue: "",
            currency: { name: "$" },
        },
        messages: [],
    },
    getters: {
        rfpChat: (state) => {
            return state.chat
        },
        chatRfpDetails: (state) => {
            return state.chatRfpDetails
        },

        showRfpChatDialog: (state) => {
            return state.chatvisible;
        },
        rfpMessages: (state) => {
            return state.messages;
        },
    },
    mutations: {
        chatRfpDetails(state, rfp) {
            state.chatRfpDetails = rfp
        },

        [SWITCH_RFP_CHAT_DIALOG](state) {
            state.chatvisible = !state.chatvisible;
        },
        [GET_RFP_MESSAGES]: (state, data) => {
            state.messages = data.messages
            state.chat = data.chat
            if (state.chat.chatId == undefined) state.chat.chatId = state.chat.id
            if (state.chat.rfpId == undefined) state.chat.rfpId = state.chat.rfp_id
            if (state.chat.customerId == undefined) state.chat.customerId = state.chat.customer_id
        },
        [ADD_RFP_MESSAGE]: (state, data) => {
            state.messages.push(data)
        },
        [UPDATE_RFP_MESSAGE]: (state, data) => {
            state.messages.forEach(function(key, item) {
                if (item.id == data.id) state.messages[key] = data
            })
        },
    },
    actions: {
        [GET_CUSTOMER_RFP_CHATS]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerChats(context.getters.customer.id);
            return results.data.data;
        },

        [GET_RFP_MESSAGES]: async(context, rfpId) => {
            var chatService = new RfpChatService();
            var results = await chatService.getSpecific(context.getters.customer.id, rfpId);
            var data = {
                messages: results.data.data.content.messages,
                chat: results.data.data.content.chat
            }
            context.commit(GET_RFP_MESSAGES, data)
            context.commit("chatRfpDetails", results.data.data.rfp)

            return results;
        },

        [GET_RFP_CHAT_MESSAGES]: async(context, chatId) => {
            var chatService = new RfpChatService();
            var results = await chatService.getChatMessages(chatId);
            var data = {
                messages: results.data.data.content.messages,
                chat: results.data.data.content.chat
            }
            context.commit(GET_RFP_MESSAGES, data);
            context.commit("chatRfpDetails", results.data.data.rfp)
        },

        [CREATE_RFP_MESSAGE]: async(context, data) => {
            var messageService = new RfpMessageService();
            data.chat_id = data.chat_id == undefined ? context.getters.rfpChat.id : data.chat_id;
            var results = await messageService.create(data)
            context.commit(ADD_RFP_MESSAGE, results.data)
            return results;
        },

        [UPDATE_RFP_MESSAGE]: async(context, data) => {
            var messageService = new RfpMessageService();
            var result = await messageService.edit(data);
            return result;
        },
    }
};